import Const from 'constants';

const defaultState = {
    data: {},
    all() {
        return {...this.data};
    },
    getById(id) {
        return this.data[id] ?? {};
    },
    hasTeams() {
        return !isEmpty(this.data);
    },
};

export default function (state = defaultState, action) {
    if (action.type === Const.SET_TEAMS) {
        state = {...state, data: action.data};
    } else if (
        inArray(action.type, [
            Const.FILTER_BY_MODE,
            Const.FILTER_BY_SITE,
            Const.FILTER_BY_SPORT,
            Const.FILTER_BY_GAME_TYPE,
            Const.FILTER_BY_SLATE,
        ])
    ) {
        state = {...state, data: {}};
    }

    return state;
}
